<template>
  <div class="card mt-5">
    <div class="card-header">
      <h2>Please click the activation link we sent to your email</h2>
      <span>
        An email has been sent to your email address containing an activation link. Please click on the link to activate your account. If you do not click the link your account will remain inactive.
        If you do not receive the email within a few minutes, please check your spam folder.
      </span>
      <p class="text-center"><span class="text-primary">{{count}}</span> please go to the <router-link to="/login">Login-page</router-link></p> 
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      count: '',
    }
  },
  created() {
    this.goLoginPage()
  },
  name: 'RegisterSuccess',
    methods: {
    goLoginPage() {
      const timejump = 20
      if (!this.timer) {
        this.count = timejump
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= timejump) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
            this.$router.push({ path: '/login' })
          }
        }, 1000)
      }
    },
  },
}
</script>